<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="580px">
      <v-card class="grid">
        <!-- close -->
        <v-toolbar elevation="0" class="title pl-2">
          <span>
            {{ $t('message.pages.organization.redirectionModal.title') }}
          </span>
          <v-spacer />
          <v-toolbar-items>
            <v-btn icon @click="handleClose">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <!-- steps -->
        <v-card-text class="pb-0" style="height: 100px">
          <v-row no-gutters>
            <v-col cols="12" v-if="!fetchLoading" style="height: 30px">
              <span
                >{{ $t('message.pages.organization.redirectionModal.text') }}
                {{ stripeLink }}</span
              >
              <v-btn
                v-if="errors.fetchError"
                small
                color="primary"
                @click="getStripe"
                >{{
                  $t('message.pages.organization.redirectionModal.action1')
                }}</v-btn
              >
            </v-col>
            <v-col cols="12" v-else style="height: 30px">
              <v-row no-gutters align="center" justify="center">
                <v-progress-circular
                  :size="20"
                  width="3"
                  color="primary"
                  indeterminate
                />
              </v-row>
            </v-col>
            <v-col cols="12" v-if="errors.fetchError" class="mt-4">
              <v-row no-gutters align="center">
                <v-alert dense outlined type="error" width="100%">
                  <span class="caption align-text d-block">
                    {{ errors.shownErrMsg }}
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon class="pb-1" size="18" v-bind="attrs" v-on="on">
                          mdi-help-circle
                        </v-icon>
                      </template>
                      <v-container
                        class="text-body-2 pa-0"
                        style="max-width: 230px"
                      >
                        {{ errors.tooltipErrMsg }}
                      </v-container>
                    </v-tooltip>
                  </span>
                </v-alert>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <!-- actions -->
        <v-card-actions class="px-8 py-6">
          <v-row no-gutters justify="center" align="center">
            <v-spacer />
            <v-btn @click="handleClose" color="primary" small class="mr-2">{{
              $t('message.actions.close')
            }}</v-btn>
            <v-btn
              :disabled="!stripeLink || stripeLink.length < 1"
              color="primary"
              small
              @click="openStripeDashboard"
            >
              {{ $t('message.actions.open') }} <v-icon>mdi-open-in-new</v-icon>
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import planApi from '@/services/planApi'
import i18n from '@/translations/lang'

export default {
  name: 'StripeRedirectionModal',
  data: () => ({
    open: false,
    fetchLoading: false,
    stripeLink: '',
    errors: {
      fetchError: false,
      shownErrMsg: 'Error',
      tooltipErrMsg: 'Error',
    },
    token: '',
  }),
  computed: {},
  mounted() {
    this.$root.$on('openStripeRedirectionModal', (token) => {
      this.token = token
      this.getStripe()
      this.open = true
    })
  },
  beforeDestroy() {
    this.$root.$off('openStripeRedirectionModal')
  },
  methods: {
    async getStripe() {
      this.clearErrors()
      this.fetchLoading = true
      let stripeRedirectUrl = 'https://dashboard.pandavideo.com.br'
      let isDotCom = !location.host.includes('.com.br')
      if (isDotCom) {
        stripeRedirectUrl = 'https://dashboard.pandavideo.com'
      }
      try {
        const { data } = await planApi.getReturnUrl(
          stripeRedirectUrl,
          this.$i18next.resolvedLanguage === 'en' ? 'en-US' : 'pt-BR',
          this.token
        )
        this.fetchLoading = false
        this.stripeLink = data.url
      } catch (error) {
        this.fetchLoading = false
        this.handleFetchError(error)
      }
    },
    handleFetchError(err) {
      this.errors.shownErrMsg = i18n.t('message.errors.unexpectedError')
      let errString = ''
      if (
        err?.response?.data &&
        err?.response?.data?.errMsg &&
        err?.response?.data?.errCode
      ) {
        errString = err.response.data.errCode + err.response.data.errMsg
      }
      this.errors.fetchError = true
      this.errors.tooltipErrMsg =
        err.msg ?? errString ?? err.response.data.message ?? 'Error'
    },
    clearErrors() {
      Object.keys(this.errors).forEach((e) => {
        if (typeof e === 'string') e = ''
        if (typeof e === Boolean) e = false
      })
    },
    openStripeDashboard() {
      window.open(this.stripeLink, '_blank')
    },
    handleClose() {
      this.open = false
    },
  },
}
</script>

<style lang="scss" scoped></style>
